import React, {  useMemo, useState } from 'react';
import { Card, Typography, Select } from 'antd';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';

const { Text } = Typography;
const { Option } = Select;

export default function EscalationsChart({ escalationsChartData = [] }) {
  const [view, setView] = useState('last7Days');

  const selectedData = escalationsChartData[view];
  console.log('select', selectedData);

  const chartData = useMemo(() => {
    if (!selectedData) return [];

    if (view === 'thisYear') {
      return (
        selectedData.monthly?.map((item) => ({
          date: item.label,
          value: item.tickets,
        })) || []
      );
    } else if (view === 'thisMonth') {
      return (
        selectedData.weeks?.map((item) => ({
          date: item.week,
          value: item.tickets,
        })) || []
      );
    } else {
      return (
        selectedData.daily?.map((item) => ({
          date: item?.label,
          value: item.tickets,
        })) || []
      );
    }
  }, [selectedData, view]);

  return (
    <Card
      size='small'
      className='escalations-card'
      style={{ margin: '0', padding: '0' }}
    >
      <div
        className='chart-header'
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div className='chart-title'>
          <span
            className='ticket-count'
            style={{
              marginBottom: '8px',
              fontSize: '16px',
              fontWeight: 500,
              color: '#000',
            }}
          >
            {selectedData?.current || 0} Tickets
          </span>
          <span className='percentage-change' style={{ marginLeft: 8 }}>
            {selectedData?.percentageChange || 0}%
          </span>
          <div>
            <Text type='secondary' style={{ fontSize: '12px' }}>
              Escalations -{' '}
              {view === 'last7Days'
                ? 'Last 7 Days'
                : view === 'thisMonth'
                ? 'This Month'
                : 'This Year'}
            </Text>
          </div>
        </div>

        <Select
          value={view}
          onChange={setView}
          size='small'
          style={{ width: 130 }}
        >
          <Option value='last7Days'>Last 7 Days</Option>
          <Option value='thisMonth'>This Month</Option>
          <Option value='thisYear'>This Year</Option>
        </Select>
      </div>

      <div style={{ width: '100%', overflowX: 'auto' }}>
        <div
          style={{
            width: `${chartData.length * 40}px`,
            minWidth: '600px',
          }}
        >
          <ResponsiveContainer width='100%' height={510}>
            <BarChart
              data={chartData}
              
              margin={{ top: 10, right: 10, bottom: 10 }}
            >
              <XAxis
                dataKey='date'
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12 }}
                interval={0}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12 }}
              />
              <Bar
                dataKey='value'
                fill='#3E97FF'
                radius={[2, 2, 0, 0]}
                barSize={10}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Card>
  );
}
